import React, { createContext, useContext } from 'react'

// The current page's language ('sv' or 'en'), set per page in
// gatsby-browser.js / gatsby-ssr.js from the page context.
const LanguageContext = createContext('sv')
// The same page in the other language, if it has been translated
const AltPathContext = createContext(null)

export const LanguageProvider = ({ lang, altPath, children }) => (
  <LanguageContext.Provider value={lang}>
    <AltPathContext.Provider value={altPath || null}>
      {children}
    </AltPathContext.Provider>
  </LanguageContext.Provider>
)

export const useLanguage = () => useContext(LanguageContext)

export const useAltPath = () => useContext(AltPathContext)

export const langFromPath = (pathname = '') =>
  pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'sv'
